module.exports = __webpack_public_path__ + "img/live-stream.12c18464.jpg";